import { DAYS_OF_WEEK } from "../../../../types.js";
// src/modules/Scheduling/shared/availability/week-order.ts
/**
* The seven days, starting on the region's first day of the week.
*
* Takes the raw `ScheduleConfig.settings.firstDayOfWeek` string, read the way
* the server reads it: only lowercase names count, and anything else (absent,
* unknown, or a legacy capitalised `'Sunday'`) starts on Monday, the backend's
* default. Lists that disagreed with the server's week would mislead.
*/
function daysOfWeekFrom(firstDay) {
	const start = DAYS_OF_WEEK.indexOf(firstDay ?? "");
	const offset = start === -1 ? DAYS_OF_WEEK.indexOf("monday") : start;
	return [...DAYS_OF_WEEK.slice(offset), ...DAYS_OF_WEEK.slice(0, offset)];
}
/**
* The first day to give atalaya's `WeekDays` / `WeekDaysPicker`, so the picker
* starts on the same day as the lists built with `daysOfWeekFrom`.
*/
function weekDaysFirstDay(firstDay) {
	return daysOfWeekFrom(firstDay)[0];
}
export { daysOfWeekFrom, weekDaysFirstDay };

//# sourceMappingURL=week-order.js.map